module.exports = __webpack_public_path__ + "img/slogan.6c70b253.webp";